import React from "react";

export default function CalloutBanner() {
  return (
    <section id="about" className="bg-black text-center py-12 w-full rounded-xl md:rounded-3xl">
      <h2 className="text-pink-600 text-3xl md:text-5xl font-extrabold tracking-tight">
        KITNE AADMI THE?
      </h2>
    </section>
  );
}
